module.exports = __webpack_public_path__ + "img/btn_select.ab3bdc80.svg";